export default "./images/WN55.jpg";